import "./Invoices.scss"
import React, { Component } from "react"
import get from "lodash/get"
import last from "lodash/last"
import moment from "moment"
import numeral from "numeral"
import { Button, Icon } from "../../lib"
import { observer } from "mobx-react"
import { getPlanById } from "../billing/utils"
import { teamStore, invoiceStore } from "../../app/stores"

function getInvoiceLines(invoice) {
  return get(invoice, "lines.data", [])
}

function getInvoicePlan(invoice) {
  const lines = getInvoiceLines(invoice)
  const planId = get(last(lines), "plan.id")
  return getPlanById(planId)
}

function getInvoiceTotal(invoice) {
  return getInvoiceLines(invoice).reduce((total, line) => {
    return (total += line.amount)
  }, 0)
}

function downloadInvoice(invoice) {
  const lines = getInvoiceLines(invoice).map(line => {
    const plan = getPlanById(get(line, "plan.id"))
    console.log("plan", plan)
    return {
      productName: `Smallchat ${plan.name}`,
      productDescription: plan.interval === 12 ? "Annually" : "Monthly",
      costString: numeral(line.amount / 100).format("$0.00"),
    }
  })
  const invoiceNumber = invoice.number
  const totalCostString = numeral(getInvoiceTotal(invoice) / 100).format(
    "$0.00"
  )
  const dateString = moment(invoice.date * 1000).format("MMMM Do YYYY")
  const customerName = `${teamStore.teamName} (${teamStore.teamEmail})`
  window.createInvoice(
    lines, // [{ productName, productDescription, costString}]
    invoiceNumber,
    totalCostString,
    dateString,
    customerName,
    "",
    () => {}
  )
}

const InvoicesList = observer(() => {
  return (
    <table className="InvoicesList">
      <tbody>
        <tr>
          <th>Plan</th>
          <th>Amount</th>
          <th>Number</th>
          <th>Date</th>
        </tr>
        {invoiceStore.invoices.map((invoice, index) => (
          <tr key={index}>
            <td className="InvoicesList_plan">
              {getPlanById(get(last(invoice.lines.data), "plan.id")).name}
            </td>
            <td className="InvoicesList_amount">
              {numeral(getInvoiceTotal(invoice) / 100).format("$0.00")}
            </td>
            <td className="InvoicesList_number">{invoice.number}</td>
            <td className="InvoicesList_date">
              {moment(invoice.date * 1000).format("YYYY/MM/DD HH:mm:ss")}
            </td>
            <td className="InvoicesList_download">
              <Button onClick={() => downloadInvoice(invoice)} styleType="text">
                <Icon name="download" />
              </Button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
})

class Invoices extends Component {
  componentDidMount() {
    invoiceStore.loadInvoices()
  }

  render() {
    return (
      <div className="Invoices">
        {invoiceStore.invoices ? (
          <InvoicesList />
        ) : invoiceStore.loading ? (
          <p>Loading...</p>
        ) : invoiceStore.error ? (
          <p>Error: {invoiceStore.error}</p>
        ) : (
          <h4>Your account does not have any invoices.</h4>
        )}
        {invoiceStore.invoices &&
        !invoiceStore.loading && (
          <footer>
            <Button onClick={() => invoiceStore.loadInvoices(true)}>
              Refresh
            </Button>
          </footer>
        )}
      </div>
    )
  }
}

Invoices.displayName = "Invoices"

export default observer(Invoices)



// WEBPACK FOOTER //
// ./src/account/invoices/Invoices.js